class RecentContactsController {
  constructor(authService, userService, loadingService, $scope) {
    "ngInject";

    this.authService = authService;
    this.userService = userService;
    this.loadingService = loadingService;

    this.contacts = [];

    $scope.$on('dashboard:viewContacts', this.listRecentContacts.bind(this));
  }

  listRecentContacts(evt, params) {    
    //Toggle Event coming from dashboard instead of page change, skip the method
    if (evt && this.contacts.length){
      return;
    }

    const ctrl = this;

    ctrl.loadingService.showLoading('contactList', 'Loading Contacts');

    ctrl.userService.recentContacts(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), params.userId)
      .then(response => {
        ctrl.contacts = response.data;
        ctrl.onLoad();
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('contactList');
      });
  }
}

export default RecentContactsController;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/recentContacts/recentContacts.controller.js